import { connect } from "react-redux";
import { getAvailablePaymentTerms, hasAlmaPayment } from "app/reducers/partnerSelector";
import AvailablePaymentTerms from "app/pages/.shared/AvailablePaymentTerms/AvailablePaymentTerms";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import {
	getPaymentModes,
	getSupportedPaymentTypes,
} from "app/pages/Booking/Payment/paymentSelector";
import { PAYMENT_METHODS } from "app/constants";

const AvailablePaymentTermsContainer = props => {
	return <AvailablePaymentTerms {...props} />;
};

const mapStateToProps = (state, props) => {
	const paymentModes = getPaymentModes(state) || [];
	const supportedPaymentTypes = getSupportedPaymentTypes(state);
	return {
		availablePaymentTerms: props.isPaymentPage
			? paymentModes.map(mode => mode.terms)
			: getAvailablePaymentTerms(state),
		isDepositEnabled: isDepositEnabled(state),
		hasAlmaPayment: props.isPaymentPage
			? supportedPaymentTypes.some(
					supportedPayment => supportedPayment.type === PAYMENT_METHODS.ALMA
			  )
			: hasAlmaPayment(state),
	};
};

export default connect(mapStateToProps)(AvailablePaymentTermsContainer);
